import { render, staticRenderFns } from "./TagFieldEditor.vue?vue&type=template&id=37c5ecc0"
import script from "./TagFieldEditor.vue?vue&type=script&lang=js"
export * from "./TagFieldEditor.vue?vue&type=script&lang=js"
import style0 from "./TagFieldEditor.vue?vue&type=style&index=0&id=37c5ecc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports